// Angular
import { Component, Input, OnInit } from '@angular/core';

// Afidium
import { RoomCode, IRoomDetail, ILanguageText } from 'libraries/hotel/models/quote';
import { Yii } from 'libraries/interfaces/Yii';
import { ILabels } from 'libraries/interfaces/ILabels';
import { ROOM_LABELS } from 'libraries/hotel/services/room-labels';

@Component({
    selector: 'room-informations',
    template: `
        <div class="roomNumber-room">
            <div class="room-description">
                <div class="room-number-name">
                    <span *ngIf="roomNumber" class="roomNumber">{{ labels.room }} {{ roomNumber }}</span>
                    <strong *ngIf="name">{{ name }}</strong>
                </div>

                <div class="metadata">
                    <span title="{{ room.xCode }}" class="xCode">{{ codeTranslation }}</span>
                </div>
            </div>
        </div>
    `,
    styles: [`
        .roomNumber {
            white-space: nowrap;
            margin-right: 0.6ex;
        }

        .roomNumber-room {
            flex: 5;
            display: flex;
            margin-right: 20px;
        }

        .selected-room {
            width: 30px;
            display: inline-block;
        }

        .room-number-name {
            margin-right: 5px;
            display: flex;
            flex-direction: column;
        }

        .metadata {
            color: #666;
            font-size: 0.8em;
        }
    `]
})
export class RoomInformationsComponent implements OnInit {
    @Input()
    public room: IRoomDetail;

    @Input()
    public roomNumber: number;

    public labels: ILabels = {
        room: Yii.t('wui-shared-js', 'Chambre')
    };

    public name: string;
    public codeTranslation: string;

    private readonly xCodeLabels: ILabels = ROOM_LABELS;

    public ngOnInit(): void {
        if (this.room && this.room.name) {
            this.name = getRoomName(this.room.name);
        }
        if (this.room && this.room.xCode) {
            this.codeTranslation = this.getCodeTranslation(this.room.xCode);
        }
    }

    private getCodeTranslation(xCode: RoomCode): string {
        if (this.xCodeLabels[xCode.toLowerCase()]) {
            return this.xCodeLabels[xCode.toLowerCase()];
        }

        return this.xCodeLabels[RoomCode.Unknown];
    }

}

function getRoomName(name: ILanguageText | string): string {
    if (typeof name === 'string') {
        return name;
    }
    return name.text;
}